import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl, getAuthToken } from '../../../services/api';

const API_BASE = () => `${getApiBaseUrl()}/api/admin/resources`;

const AnalyticsReportsTab = () => {
  const { t } = useTranslation('resourcesManagement');
  const [data, setData] = useState({ byExam: [], bySubject: [], byLevel: [] });
  const [days, setDays] = useState(30);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${API_BASE()}/analytics?days=${days}`, { headers })
      .then((r) => r.json())
      .then((res) => res.success && setData({ byExam: res.byExam || [], bySubject: res.bySubject || [], byLevel: res.byLevel || [] }))
      .finally(() => setLoading(false));
  }, [days]);

  const exportCsv = (type) => {
    const token = getAuthToken();
    if (!token) return;
    fetch(`${API_BASE()}/export?type=${type}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.text())
      .then((csv) => {
        const blob = new Blob([csv], { type: 'text/csv' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = type === 'downloads' ? 'exam_downloads.csv' : 'exams.csv';
        a.click();
        URL.revokeObjectURL(a.href);
      })
      .catch(() => {});
  };

  if (loading) return <div className="loading-message">Loading analytics...</div>;
  return (
    <div className="tab-content">
      <div style={{ marginBottom: 16, display: 'flex', gap: 12, alignItems: 'center' }}>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))}>
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
        </select>
        <button type="button" className="action-btn" onClick={() => exportCsv('exams')}>Export exams CSV</button>
        <button type="button" className="action-btn" onClick={() => exportCsv('downloads')}>Export downloads CSV</button>
      </div>
      <h4 className="resources-section-title">{t('analytics.downloadsPerExam')}</h4>
      <div className="resources-table-wrap">
        <table className="resources-table">
          <thead>
            <tr><th>Exam</th><th>Level</th><th>Year</th><th>Subject</th><th>Downloads</th></tr>
          </thead>
          <tbody>
            {data.byExam.slice(0, 30).map((r) => (
              <tr key={r.id}>
                <td>{r.title}</td>
                <td>{r.level}</td>
                <td>{r.year}</td>
                <td>{r.subject}</td>
                <td>{r.downloads ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <h4 className="resources-section-title">{t('analytics.bySubject')}</h4>
      <div className="resources-table-wrap">
        <table className="resources-table">
          <thead>
            <tr><th>Subject</th><th>Downloads</th></tr>
          </thead>
          <tbody>
            {data.bySubject.map((r, i) => (
              <tr key={i}><td>{r.subject}</td><td>{r.downloads ?? 0}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
      <h4 className="resources-section-title">{t('analytics.byLevel')}</h4>
      <div className="resources-table-wrap">
        <table className="resources-table">
          <thead>
            <tr><th>Level</th><th>Downloads</th></tr>
          </thead>
          <tbody>
            {data.byLevel.map((r, i) => (
              <tr key={i}><td>{r.level}</td><td>{r.downloads ?? 0}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnalyticsReportsTab;
